// Cart drawer (sections/tingit_cart_drawer.liquid), ported from the Cellmetics cell_cart_drawer.js (jQuery -> vanilla).
// API: window.openCartDrawer(showSkeleton, trigger), window.closeCartDrawer(), window.refreshCartDrawer(skipGift, sectionsData)
// Every cart mutation asks for window.tingitCartDrawerSections and passes response.sections to refreshCartDrawer.

window.tingitCartDrawerSections = "tingit_cart_drawer,cart-icon-bubble,cart-icon-bubble-burger";

var tingitCartSkeletonShownAt = null;
var tingitCartTrigger = null;
var TINGIT_CART_QTY_DEBOUNCE_MS = 500;
var tingitCartGiftRequest = null;

function tingitCartRoot() {
  return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
}

function tingitCartPost(url, body) {
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body),
  }).then(function (response) {
    return response.json().then(function (data) {
      if (!response.ok || data.status) throw data;
      return data;
    });
  });
}

function tingitCartSectionHTML(html, selector) {
  var el = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  return el ? el.innerHTML : null;
}

window.openCartDrawer = function (showSkeleton, trigger) {
  var outer = document.querySelector(".cd_outer");
  if (!outer) return;
  tingitCartTrigger = trigger || document.activeElement;
  outer.style.display = "flex";
  document.body.classList.add("overflow-hidden-cart-drawer");
  document.documentElement.classList.add("overflow-hidden-cart-drawer");
  if (showSkeleton) {
    outer.querySelector(".cd_skeleton").classList.add("cd_skeleton--visible");
    tingitCartSkeletonShownAt = Date.now();
  }
  setTimeout(function () {
    outer.classList.add("active");
    var close = outer.querySelector(".cd_close");
    if (close) close.focus({ preventScroll: true });
  }, 100);
};

window.closeCartDrawer = function () {
  var outer = document.querySelector(".cd_outer");
  if (!outer) return;
  outer.classList.remove("active");
  document.body.classList.remove("overflow-hidden-cart-drawer");
  document.documentElement.classList.remove("overflow-hidden-cart-drawer");
  setTimeout(function () {
    outer.style.display = "none";
  }, 500);
  if (tingitCartTrigger && tingitCartTrigger.focus) tingitCartTrigger.focus({ preventScroll: true });
  tingitCartTrigger = null;
};

window.refreshCartDrawer = function (skipGift, sectionsData, giftRoundsLeft) {
  if (!document.querySelector(".cd_outer")) return;
  if (typeof giftRoundsLeft !== "number") giftRoundsLeft = 3;

  // If sections came with a cart mutation response, skip the fetch
  // (cache: "no-store" since this is a page URL and can otherwise be served stale after a back-navigation)
  var sectionPromise = sectionsData
    ? Promise.resolve(sectionsData)
    : fetch(tingitCartRoot() + "?sections=" + window.tingitCartDrawerSections, { cache: "no-store" }).then(function (r) {
        return r.json();
      });

  return sectionPromise.then(function (sections) {
    var cartHtml = sections["tingit_cart_drawer"] && tingitCartSectionHTML(sections["tingit_cart_drawer"], ".cart_content--js");
    if (cartHtml !== null && cartHtml !== undefined) {
      document.querySelector(".cart_content--js").innerHTML = cartHtml;
    } else {
      console.warn("Cart drawer section not found");
    }

    // Header cart icons (same sections the old Zap drawer refreshed)
    ["cart-icon-bubble", "cart-icon-bubble-burger"].forEach(function (id) {
      var el = document.getElementById(id);
      var html = sections[id] && tingitCartSectionHTML(sections[id], ".shopify-section");
      if (el && html !== null && html !== undefined) el.innerHTML = html;
    });

    var elapsed = tingitCartSkeletonShownAt ? Date.now() - tingitCartSkeletonShownAt : 500;
    var delay = sectionsData ? 0 : Math.max(0, 500 - elapsed);
    tingitCartSkeletonShownAt = null;
    var skeleton = document.querySelector(".cd_skeleton");
    skeleton.classList.add("cd_skeleton--hiding");
    setTimeout(function () {
      skeleton.classList.remove("cd_skeleton--visible", "cd_skeleton--hiding");
    }, delay + 200);

    if (skipGift) return;
    var giftRequest = tingitCartSyncGift(document.querySelector(".cart_content--js .cd_gift-state"));
    if (giftRequest) {
      return giftRequest.then(function (response) {
        return window.refreshCartDrawer(giftRoundsLeft <= 1, response.sections, giftRoundsLeft - 1);
      });
    }
  });
};

// Free gift: the rule is computed in Liquid, see .cd_gift-state in sections/tingit_cart_drawer.liquid.
// Adds the gift line (property _free_gift) when eligible, removes it when not, keeps its quantity at data-gift-quantity.
// Returns the cart request (resolving to the cart response, errors logged and swallowed), or undefined when nothing changes.
// Used by the drawer and by assets/tingit_cart_page_gift.js on /cart.
function tingitCartSyncGift(state) {
  if (!state) return;
  if (tingitCartGiftRequest) return tingitCartGiftRequest;
  var eligible = state.dataset.eligible === "true";
  var target = eligible ? parseInt(state.dataset.giftQuantity) || 1 : 0;
  // All gift line keys: Shopify can split the gift line when the discount covers only some units
  var lineKeys = (state.dataset.lineKeys || "").split(",").filter(Boolean);
  var lineQuantity = parseInt(state.dataset.lineQuantity) || 0;
  var request = null;

  if (target > 0 && !lineKeys.length) {
    request = tingitCartPost(window.routes.cart_add_url + ".js", {
      id: parseInt(state.dataset.variantId),
      quantity: target,
      properties: { _free_gift: "true" },
      sections: window.tingitCartDrawerSections,
    });
  } else if (lineKeys.length && lineQuantity !== target) {
    request = tingitCartSetKeysQuantity(lineKeys, target);
  }
  if (!request) return;

  tingitCartGiftRequest = request
    .catch(function (err) {
      console.error("Free gift update failed:", err);
      return {};
    })
    .finally(function () {
      tingitCartGiftRequest = null;
    });
  return tingitCartGiftRequest;
}

// The customer removes a gift that wasn't free: remove all its lines and remember it (cart attribute),
// so tingitCartSyncGift doesn't add it back for this cart.
function tingitCartDeclineGift(keys) {
  return tingitCartPost(window.routes.cart_update_url + ".js", {
    updates: keys.reduce(function (updates, key) {
      updates[key] = 0;
      return updates;
    }, {}),
    attributes: { _tingit_gift_declined: "true" },
    sections: window.tingitCartDrawerSections,
  });
}

// When returning via the browser back button (e.g. from /checkout), the page can come back from bfcache
// OR the regular HTTP cache with stale cart markup, so refresh on every pageshow.
window.addEventListener("pageshow", function () {
  window.refreshCartDrawer(false);
});

// Header cart icons open the drawer instead of going to /cart
document.addEventListener("click", function (evt) {
  var cartLink = evt.target.closest("#cart-icon-bubble, #cart-icon-bubble-burger");
  if (!cartLink || !document.querySelector(".cd_outer")) return;
  evt.preventDefault();
  window.openCartDrawer(false, cartLink);
});

document.addEventListener("keydown", function (evt) {
  if (evt.key === "Escape" && document.querySelector(".cd_outer.active")) window.closeCartDrawer();
});

document.addEventListener("click", function (evt) {
  var target = evt.target;

  // Overlay / close button
  if (target.classList.contains("cd_outer") || target.closest(".cd_close")) {
    window.closeCartDrawer();
    return;
  }

  // Subscription frequency dropdown
  var freqThumb = target.closest(".cd_item-freq-thumb");
  document.querySelectorAll(".cd_item-freq-thumb.active").forEach(function (thumb) {
    if (thumb === freqThumb) return;
    thumb.classList.remove("active");
    thumb.setAttribute("aria-expanded", "false");
    thumb.nextElementSibling.hidden = true;
  });
  if (freqThumb) {
    var isOpen = freqThumb.classList.toggle("active");
    freqThumb.setAttribute("aria-expanded", isOpen);
    freqThumb.nextElementSibling.hidden = !isOpen;
    return;
  }

  var freqVal = target.closest(".cd_item-freq-val");
  if (freqVal) {
    tingitCartChangePlan(freqVal);
    return;
  }

  var plus = target.closest(".cd_item-plus");
  var minus = target.closest(".cd_item-minus");
  if (plus || minus) {
    tingitCartScheduleQuantityChange((plus || minus).closest(".cd_item"), plus ? 1 : -1);
    return;
  }

  var remove = target.closest(".cd_item-remove");
  if (remove) {
    var item = remove.closest(".cd_item");
    item.classList.add("loading");
    // A gift that wasn't free: remove all its lines and remember it, so tingitCartSyncGift doesn't add it back
    var request =
      item.dataset.gift === "true"
        ? tingitCartDeclineGift(item.dataset.keys.split(",").filter(Boolean))
        : tingitCartSetLineQuantity(item, 0);
    request
      .then(function (response) {
        window.refreshCartDrawer(false, response.sections);
      })
      .catch(function (err) {
        console.error("Cart remove failed:", err);
        item.classList.remove("loading");
      });
    return;
  }

  var upsellBtn = target.closest(".tingit_upsell-add-btn, .cd_bundle-upsell_btn");
  if (upsellBtn) {
    evt.preventDefault();
    tingitCartAddUpsell(upsellBtn);
  }
});

function tingitCartAddUpsell(btn) {
  if (btn.classList.contains("loading")) return;
  btn.classList.add("loading");

  var data = {
    id: btn.dataset.id,
    quantity: 1,
    sections: window.tingitCartDrawerSections,
  };
  // Line item property read by the discount: only sent when the card shows a discount
  var offer = parseFloat(btn.dataset.offer);
  if (offer > 0) data.properties = { _OFFER: btn.dataset.offer };

  tingitCartPost(window.routes.cart_add_url + ".js", data)
    .then(function (response) {
      window.refreshCartDrawer(false, response.sections);
    })
    .catch(function (error) {
      console.error("Upsell error:", error);
      btn.classList.remove("loading");
    });
}

function tingitCartChangePlan(freqVal) {
  var select = freqVal.closest(".cd_item-freq-select");
  var thumb = select.querySelector(".cd_item-freq-thumb");
  var item = freqVal.closest(".cd_item");
  var qty = parseInt(item.querySelector(".cd_item-val").textContent.trim()) || 1;

  thumb.classList.remove("active");
  thumb.setAttribute("aria-expanded", "false");
  select.querySelector(".cd_item-freq-content").hidden = true;
  item.classList.add("loading");

  tingitCartPost(window.routes.cart_change_url + ".js", { id: item.dataset.key, quantity: 0 })
    .then(function () {
      return tingitCartPost(window.routes.cart_add_url + ".js", {
        id: parseInt(item.dataset.variantId),
        quantity: qty,
        selling_plan: parseInt(freqVal.dataset.id),
        sections: window.tingitCartDrawerSections,
      });
    })
    .then(function (response) {
      window.refreshCartDrawer(false, response.sections);
    })
    .catch(function (err) {
      console.error("Failed to change selling plan:", err);
      item.classList.remove("loading");
    });
}

// Sets the quantity of a drawer row. A row can stand for several cart lines of the same variant
// (Shopify splits lines when a discount covers only some units): the first line gets the quantity, the others 0.
function tingitCartSetLineQuantity(item, quantity) {
  return tingitCartSetKeysQuantity((item.dataset.keys || item.dataset.key).split(",").filter(Boolean), quantity);
}

// One key: /cart/change.js. Several keys (lines of one variant): the first gets the quantity, the others 0.
function tingitCartSetKeysQuantity(keys, quantity) {
  if (keys.length < 2) {
    return tingitCartPost(window.routes.cart_change_url + ".js", {
      id: keys[0],
      quantity: quantity,
      sections: window.tingitCartDrawerSections,
    });
  }
  var updates = {};
  keys.forEach(function (key, index) {
    updates[key] = index === 0 ? quantity : 0;
  });
  return tingitCartPost(window.routes.cart_update_url + ".js", {
    updates: updates,
    sections: window.tingitCartDrawerSections,
  });
}

// +/- update the number right away and send one /cart/change.js after the clicks stop
function tingitCartScheduleQuantityChange(item, delta) {
  var val = item.querySelector(".cd_item-val");
  var currentVal = typeof item._pendingQty === "number" ? item._pendingQty : parseFloat(val.textContent) || 0;
  currentVal = Math.max(0, currentVal + delta);

  item._pendingQty = currentVal;
  val.textContent = currentVal;

  clearTimeout(item._qtyDebounceTimer);
  item._qtyDebounceTimer = setTimeout(function () {
    item._pendingQty = null;
    item.classList.add("loading");

    tingitCartSetLineQuantity(item, currentVal)
      .then(function (response) {
        window.refreshCartDrawer(false, response.sections);
      })
      .catch(function (err) {
        // e.g. not enough stock: re-render the real cart
        console.error("Cart quantity change failed:", err);
        window.refreshCartDrawer(false);
      });
  }, TINGIT_CART_QTY_DEBOUNCE_MS);
}
